import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

export const WhatsAppButton = () => {
  const [isHovered, setIsHovered] = useState(false);

  const whatsappNumber = '+971566671468'; // Remove spaces for URL
  const message = 'Hi Think Mechanic, I need help with my German car repair';
  const whatsappUrl = `https://wa.me/${whatsappNumber.replace(/\s/g, '')}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-4 md:bottom-6 right-4 md:right-6 z-50 flex items-center justify-center transition-all duration-300 group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        width: isHovered ? 'auto' : window.innerWidth < 768 ? '52px' : '60px',
        height: window.innerWidth < 768 ? '52px' : '60px',
        background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
        borderRadius: window.innerWidth < 768 ? '26px' : '30px',
        boxShadow: '0 4px 12px rgba(37, 211, 102, 0.4)',
        padding: isHovered ? '0 20px' : '0',
      }}
    >
      {/* WhatsApp Icon */}
      <div className="flex items-center justify-center">
        <svg
          width={window.innerWidth < 768 ? "28" : "32"}
          height={window.innerWidth < 768 ? "28" : "32"}
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="flex-shrink-0"
        >
          <path
            d="M16 0C7.164 0 0 7.164 0 16c0 2.828.744 5.58 2.156 7.984L.057 31.75l8.024-2.044A15.936 15.936 0 0016 32c8.836 0 16-7.164 16-16S24.836 0 16 0z"
            fill="#25D366"
          />
          <path
            d="M25.208 22.868c-.348.98-2.056 1.796-2.928 1.912-.756.096-1.744.136-2.816-.176-.648-.188-1.484-.44-2.548-.86-4.468-1.764-7.38-6.268-7.604-6.556-.22-.288-1.8-2.396-1.8-4.572 0-2.176 1.14-3.244 1.544-3.688.404-.444.884-.556 1.18-.556.296 0 .592.004.852.016.272.012.636-.104.996.76.364.872 1.244 3.036 1.352 3.256.108.22.18.476.036.764-.144.288-.216.468-.432.72-.216.252-.456.564-.652.756-.216.212-.44.44-.188.864.252.424 1.12 1.848 2.404 2.992 1.652 1.472 3.044 1.932 3.476 2.148.432.216.684.18.936-.108.252-.288 1.08-1.26 1.368-1.692.288-.432.576-.36 1.728.216 1.152.572 2.816 1.328 3.3 1.568.484.24.808.356.924.552.116.196.116 1.132-.232 2.112z"
            fill="#fff"
          />
        </svg>

        {/* Text that appears on hover */}
        <span
          className="text-white font-semibold ml-3 whitespace-nowrap overflow-hidden transition-all duration-300"
          style={{
            width: isHovered ? 'auto' : '0',
            opacity: isHovered ? 1 : 0,
          }}
        >
          Chat with us
        </span>
      </div>

      {/* Pulse animation ring */}
      <div
        className="absolute inset-0 rounded-full"
        style={{
          background: '#25D366',
          opacity: 0.3,
          animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
        }}
      />

      <style>{`
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
            opacity: 0.3;
          }
          50% {
            transform: scale(1.1);
            opacity: 0;
          }
        }
      `}</style>
    </a>
  );
};
